/* eslint-disable react/forbid-prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import { iconImage } from './images';

const Icon = props => {
	const {
		className,
		iconName,
		style,
		altText,
		id,
		ariaHidden
	} = props;

	const altImgText = altText !== undefined ? altText : `${iconName} icon`;

	return (
		<img
			id={id}
			aria-hidden={ariaHidden}
			src={iconImage(iconName)}
			alt={altImgText}
			style={style}
			className={className} />
	);
};

/**
 * Helpful info for adding prop types
 * https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
 */
Icon.propTypes = {
	className: PropTypes.string,
	iconName: PropTypes.string.isRequired,
	style: PropTypes.object,
	altText: PropTypes.string,
	ariaHidden: PropTypes.bool,
	id: PropTypes.string
};

Icon.defaultProps = {
	className: '',
	style: null,
	altText: null,
	ariaHidden: true,
	id: null
};

export default Icon;
